var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 9.92968V8.57111C10.5996 5.41981 13.1347 2.32453 16.286 2.0304C20.0395 1.66625 23.2048 4.62148 23.2048 8.305V10.2378",
    stroke: "#064E72",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7005 29.9997H21.1039C26.7343 29.9997 27.7427 27.7448 28.0368 24.9997L29.0873 16.5962C29.4654 13.1788 28.485 10.3916 22.5045 10.3916H11.2999C5.3194 10.3916 4.33899 13.1788 4.71715 16.5962L5.76759 24.9997C6.06171 27.7448 7.07013 29.9997 12.7005 29.9997Z",
    stroke: "#064E72",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0945 16H22.1124",
    stroke: "#064E72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2888 16H12.3068",
    stroke: "#064E72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlue);
export default __webpack_public_path__ + "static/media/CartBlue.4116ac1f.svg";
export { ForwardRef as ReactComponent };